import { type FC, useMemo } from 'react'
import { Modal } from '../../components/Modal/Modal'
import { type RoleType } from '../../models/Role'
import { type InviteResponse } from '../../store/auth/auth'
import { buySeatStepModalProps } from './buySeatStepModal'
import { seatTypeLabels } from './roleChangeSeatImpact'
import { inviteName } from './teamRows'
import { useBuySeat } from './useBuySeat'

export interface BuySeatDialogProps {
  invitationId: string
  seatType: RoleType
  email: string
  firstLine: string
  secondLine: string
  centered?: boolean
  onDismiss: () => void
  onSeatsChanged: () => void
  onSent: () => void
  onGone: () => void
}

export const BuySeatDialog: FC<BuySeatDialogProps> = ({
  invitationId,
  seatType,
  email,
  firstLine,
  secondLine,
  centered = false,
  onDismiss,
  onSeatsChanged,
  onSent,
  onGone,
}) => {
  const target = useMemo(() => ({ invitationId, seatType, email }), [invitationId, seatType, email])
  const buy = useBuySeat(target, { onSeatsChanged, onSent, onGone })

  return <Modal show headerBodySeparator centered={centered} {...buySeatStepModalProps({ firstLine, secondLine, buy, onDismiss })} />
}

export interface BuySeatModalProps {
  invite: InviteResponse
  seatType: RoleType
  onHide: () => void
  onSeatsChanged: () => void
}

export const BuySeatModal: FC<BuySeatModalProps> = ({ invite, seatType, onHide, onSeatsChanged }) => (
  <BuySeatDialog
    invitationId={invite.id}
    seatType={seatType}
    email={invite.user.email}
    firstLine={`You're about to buy 1 ${seatTypeLabels[seatType]} seat for ${inviteName(invite.user)}.`}
    secondLine="Once you confirm, we'll send their invitation and their status changes to Pending."
    onDismiss={onHide}
    onSeatsChanged={onSeatsChanged}
    onSent={onHide}
    onGone={onHide}
  />
)
